import moment from "moment";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";
import { getUserAccess } from "../../../utils/organization-helpers";
import ChallengeReport from "./ChallengeReport";

const ChallengeReportController = async ({ req, res, load, locals }) => {
  const { query } = req;

  const dateFrom =
    query.dateFrom || moment().subtract(30, "days").format("YYYYMMDD");
  const dateTo = query.dateTo || moment().format("YYYYMMDD");

  const { userCanAccessToPush } = getUserAccess(
    locals.activeUser,
    locals.organizationOwner,
    locals.organizationPermissions || [],
    locals.organizationRoles || []
  );

  // PRESS and PERFORM share one "Gym members" tab; old links still land on it.
  const LEGACY_GYM_TYPES = new Set(["press", "perform"]);
  const VALID_TYPES = new Set(["push", "pull", "gym"]);
  const type = LEGACY_GYM_TYPES.has(query.type)
    ? "gym"
    : VALID_TYPES.has(query.type)
      ? query.type
      : userCanAccessToPush
        ? "push"
        : "pull";

  // Board audience can be narrowed to one program (Team board).
  // The query parser coerces numeric-looking values, so compare as strings.
  const programId = query.programId ? String(query.programId) : null;
  const templateId = query.templateId ? String(query.templateId) : null;
  const memberView = String(query.memberView) === "1" && !!templateId;

  await Promise.all([
    load("challengeReport", { dateFrom, dateTo, type }),
    load("leaderboardBoards", { audience: type, programId }),
    memberView &&
      load("leaderboardPreview", {
        templateId,
        audience: type,
        programId,
      }),
  ]);

  const modal = query.modal || {};
  locals.modal = {
    "activity-feed": <ActivityDrawer />,
  }[modal.type];

  res.body = (
    <ChallengeReport
      dateFrom={dateFrom}
      dateTo={dateTo}
      type={type}
      programId={programId}
      memberView={memberView}
      previewTemplateId={memberView ? templateId : null}
    />
  );
};

export default ChallengeReportController;
